import React, { useEffect, useState } from "react";
import style from "./home.module.css";
import { Row, Col, ButtonGroup, Button, Form, Dropdown, Card } from "react-bootstrap";
import CenterList from "./CenterList";
import { getAllCenters, getcountrieswhereCampaigns } from "../../apis/CenterApis";
import { useDispatch } from "react-redux";
import useGetUser from "../../customHook/useGetUser";
import Slider from "react-slick";
import { GoSearch } from "react-icons/go";
import Movement from "./Movement";
import Newsletter from "./newsletter";
import Neighbour from "./neighbour";
import { Helmet } from "react-helmet-async";
import { Country, State } from "country-state-city";
import { FaChevronDown } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { getStateForCountry } from "../../apis/CenterApis";


const Home = () => {
  useGetUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [centerList, setCenterList] = useState();

  useEffect(() => {
    dispatch(getAllCenters({ page: 1, limit: 6 })).then((res) => {
      if (res?.centersList) {
        setCenterList(res?.centersList);
      }
    });
  }, []);

  const location = useLocation();
useEffect(() => {
  if (location.hash) {
    const element = document.querySelector(location.hash);
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }
}, [location]);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const partners = [
    {
      message:
        "We hit our goal in just 3 days! Fundlife.me made it so easy to reach our community.",
      name: "Jane Doe",
      role: "Organizer",
      image: "/images/dashboard/User1.svg",
    },
    {
      message:
        "Thanks to Fundlife.me, my mother’s medical treatment was funded by complete strangers. Forever grateful!",
      name: "Hellena John",
      role: "Co-founder",
      image: "/images/dashboard/User2.svg",
    },
    {
      message:
        "I donated to a clean water project and got updates the whole way. Felt like I was part of the mission!",
      name: "David Oshodi",
      role: "Manager",
      image: "/images/dashboard/User3.svg",
    },
    {
      message:
        "We hit our goal in just 3 days! Fundlife.me made it so easy to reach our community.",
      name: "Jane Doe",
      role: "Organizer",
      image: "/images/dashboard/User1.svg",
    },
    {
      message:
        "Thanks to Fundlife.me, my mother’s medical treatment was funded by complete strangers. Forever grateful!",
      name: "Hellena John",
      role: "Co-founder",
      image: "/images/dashboard/User2.svg",
    },
    {
      message:
        "I donated to a clean water project and got updates the whole way. Felt like I was part of the mission!",
      name: "David Oshodi",
      role: "Manager",
      image: "/images/dashboard/User3.svg",
    },
  ];
  // const countrylist = [
  //   {
  //     isoCode: "CA",
  //     name: "Canada",
  //   },
  //   {
  //     isoCode: "MX",
  //     name: "Mexico",
  //   },
  //   {
  //     isoCode: "PR",
  //     name: "Puerto Rico",
  //   },
  //   {
  //     isoCode: "US",
  //     name: "United States",
  //   },
  // ];
  const countrylist = Country.getAllCountries();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [serchedCampaing, setSearchedCampaign] = useState("");


  const handleCreate = () => {
    navigate("/campaign-register")
  }

  const handleDonate = () => {
    navigate("/search-campaign")
  }
  useEffect(() => {
    dispatch(getcountrieswhereCampaigns()).then((res) => {
      if (res?.countries?.length) {

        console.log("Response from getcountrieswhereCampaigns:", res.countries);
        console.log("Response from getcountrieswhereCampaigns Length:", res.countries.length);
        const countries = res.countries
          .filter(country => country !== null)
          .map(countryName => {
            const country = Country.getAllCountries().find(c => c.name.toLowerCase() === countryName.toLowerCase());
            return country || { name: countryName }; // Fallback if country not found
          });
        // setCountries(res?.countries);
        // console.log("All countries checking:", countries);
        setCountries(countries);

      }
    });
    // setCountries(countrylist);
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      setSelectedState("");


      dispatch(getStateForCountry({ country: selectedCountry.name })).then((res) => {
        if (res?.states?.length > 0) {
          setStates(res.states);
        } else {
          setStates([]);
        }
        console.log("Selected country:", selectedCountry.name);
        console.log("Fetched states from API:", res?.states);
      });
    } else {
      setStates([]);
      setSelectedState("");
    }

  }, [selectedCountry]);

  const handleSerach = () => {
    let serchedData;
    if (serchedCampaing?.trim()) {
      serchedData = serchedCampaing;
    } else if (selectedState) {
      serchedData = selectedState?.name;
    } else if (selectedCountry) {
      serchedData = selectedCountry?.name;
    }
    if (!serchedData) {
      navigate("/search-campaign");
    };

    navigate("/search-campaign", { state: serchedData });
  };
   

  return (
    <>
      <Helmet>
        <title>FundLife – Together We Can Fund Life</title>
        <meta
          name="description"
          content="Explore compassionate alternatives to abortion, empowering women with choices that safeguard life and mental well-being. Support matters."
        />
        {/* <meta
          property="og:description"
          content="Explore compassionate alternatives to abortion, empowering women with choices that safeguard life and mental well-being. Support matters."
        /> */}
        {/* <meta
          name="keywords"
          content="Abortion alternatives,Conscience choice,Forgotten women,Psychological consequences,Unplanned pregnancies,Pregnancy support,Abortion regret,Community outreach,Advocacy and policy,Volunteer support"
        /> */}
      </Helmet>
      <div className=" bg-main mb-3  mb-sm-0 ">
        <div style={{ height: "135px" }} />
        <div className=" innercontainer pt-5 pb-4">
          <Row className="m-0 p-0 ">
            <Col md={6} className="text-center text-md-start">
              <div>
                <img
                  // src="/images/dashboard/bannerl.png"
                  src="/homemain.svg"
                  alt="leftbanner"
                   fetchpriority="high"
                  className={style.webkitfull}
                  width="584"
                  height="285"

               
                />
              </div>

              <div className={style.bannerBtn}>

                {/* <button className={style.createBtn} onClick={handleCreate}>Create</button> <button className={style.buttonDonate} onClick={handleDonate}>Donate</button> */}
              </div>
            </Col>
            <Col md={6} className="text-end">
              <div className="mt-4 mt-md-0">
                <img
                  src="/images/dashboard/bannerr1.webp"
                  alt="leftbanner"
                    fetchpriority="high"
                   decoding="async"
                  className={style.webkitfull}
                  width="511"
                  height="401"
                />
              </div>
            </Col>
            <div className={`mx-auto mt-5`}>
              <Row className="text-center text-white gx-4 gy-4">
                <Col md={4} className="d-flex">
                  <div className={`${style.missionBox} p-4 w-100 d-flex flex-column justify-content-between`}>
                    <div>
                      <img src="/1 icon.svg" alt="icon"   width="70" height="70"/>
                      <h3 >Mission</h3>
                      <p>
                        To harness the power of crowdfunding to promote and raise funds for
                        life-affirming organizations.
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={4} className="d-flex">
                  <div className={`${style.missionBox} p-4 w-100 d-flex flex-column justify-content-between`}>
                    <div>
                      <img src="/2 icon.svg"  alt="icon2"  width="70" height="70"/>
                      <h3 >Vision</h3>
                      <p>
                        To create a future where life-affirming missions never lack the funding to flourish.
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={4} className="d-flex">
                  <div className={`${style.missionBox} p-4 w-100 d-flex flex-column justify-content-between`}>
                    <div>
                      <img src="/3 icon.svg" alt="icon3"  width="70" height="70" />
                      <h3 >Aim</h3>
                      <p>To make life a viable choice by giving individuals the support and hope they need to move forward.</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

          </Row>
       
        </div>
      </div>

      <div className="container">
        <div className={style.sectionb}>
          <img src="sectionb.webp" className="w-100"  alt="section"/>
        </div>
      </div>
    

      <div className={style.maincentercontainer}>
        <div className="container">
          <div className="text-center ">
            {/* <div className=" fs-3">Features</div> */}
            <div className={style.centerlistheading}>
              <h1>Ready to help Keep Hope Alive?

              </h1>
              <h1>Let’s take the next step</h1>
            </div>
          
          </div>
        </div>
 
        <div className="container ">
       
  <Row className="gy-4 mt-2">
    {/* Left big card */}
    <Col lg={6}>
      <div className={style.ctaMainCard1}>
    
        <div className={style.ctaContent1}>
          <h3>Start a crowd campaign in support of an existing organization today!</h3>
          <p>It will take less than 3 minutes to Keep Hope Alive.</p>
          <button className={style.ctaBtn} onClick={() => navigate("/campaign-register")}>Start Campaign</button>
        </div>
      </div>
    </Col>

    {/* Right side — 2 small cards */}
    <Col lg={6}>
      {/* Top small */}
      <div className={style.ctaSmallCard2}>
     
        <div className={style.ctaContent2}>
          <h3 >Donate now and turn your compassion into practical hope.</h3>
          <p>Every gift matters.</p>
          <button className={style.ctaBtn} onClick={() => navigate("/search-campaign")}>Donate Now</button>
        </div>
      </div>

      {/* Bottom small */}
      <div className={style.ctaSmallCard3}>
        <div className={style.comingSoonOverlay}>
          <span className={style.comingSoonText}>Coming Soon!</span>
        </div>
        <div className={style.ctaContent3}>
          <h3>Register your life-affirming organization</h3>
          <p>
            You're doing the work. Let us help fund it. You walk with families
            in crisis, we walk with you!
          </p>
          <button className={style.ctaBtn} onClick={() => navigate("/contactus")}>Register Now</button>
        </div>
      </div>
    </Col>
  </Row>

        </div>
      </div>
 <CenterList centerList={centerList} showfilter={false} />
 <div id="newsletter-section">
      <Newsletter />
      </div>
    </>
  );
};

export default Home;
